<!-- 实时交易 -->
<template>
  <div class="realtime">
    <div class="realtime-header">实时交易</div>
    <div class="realtime-con">
      <swiper v-if="realtimeList.length>0" :options="swiperOptionReal" style="height: 455px">
        <swiper-slide v-for="(item,index) in realtimeList" :key="index" class="realtime-swiper-slide">
          <ul class="realtime-item cleatfloat">
            <li class="realtime-li"><span :title="item.createDate">{{ item.createDate }}</span></li>
            <li class="realtime-li"><span :title="item.goodsCompany">{{ item.goodsCompany }}</span></li>
            <li class="realtime-li"><span :title="item.goodsTypeLabel">{{ item.goodsTypeLabel }}</span></li>
            <li class="realtime-li"><span :title="item.weight" >{{ item.weight }}吨</span></li>
            <li class="realtime-li"><span>已成交</span></li>
          </ul>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import * as get from '@/api/home/home.js' // 请求接口

export default {
  data() {
    return {
      // 实时交易
      realtimeList: [],
      // 实时交易轮播
      swiperOptionReal: {
        direction: 'vertical', // 纵轴
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        loop: true, // 开启自动播放
        slidesPerView: 7, // 排放多少个
        centeredSlides: true, // 循环播放
        autoplay: {
          delay: 2000, // 自动播放时间
          disableOnInteraction: false
        }
      }
    }
  },
  created() {
    // 实时交易
    get.realtimeDeal().then(res => {
      this.realtimeList = res.result
    }).catch(error => {
      console.log(error)
    })
  },
  methods: {

  }
}
</script>

<style scoped lang='scss'>
  /*实时交易*/
  .realtime{
    width: 100%;
    height: 500px;
    padding-top: 30px;
    .realtime-header{
      position: relative;
      width: 100%;
      height: 40px;
      font-size: 40px;
      color: #060606;
      text-indent: 20px;
      margin-bottom: 20px;
      &:before{
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        left: 0;
        top: 12px;
        border-bottom: 8px solid transparent;
        border-top: 8px solid transparent;
        border-left: 8px solid #BE2316;
      }

    }
    .realtime-con{
      position: relative;
      width: 800px;
      height: 390px;
      overflow: hidden;
      .realtime-swiper-slide{
        height: 64px;
      }
      .realtime-item{
        width: 100%;
        height: 64px;
        border-bottom: 1px dashed #AEAEAE;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        .realtime-li{
          width: 100%;
          height: 64px;
          line-height: 64px;
          float: left;
          &:nth-child(1){
            width: 180px;
            white-space:nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
            span{
              color: #555555;
              font-size: 14px;
            }
          }
          &:nth-child(2){
            width: 220px;

            white-space:nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
            span{
              color: #BE2316;
            }
          }
          &:nth-child(3){
            width: 150px;

            white-space:nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
            span{
              color: #555555;
              font-size: 14px;
            }
          }
          &:nth-child(4){
            width: 130px;

            white-space:nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;
            span{
              color: #0D60DC;
              font-size: 14px;
            }
          }
          &:nth-child(5){
            width: 100px;

            span{
              color: #419911;
              font-size: 14px;
            }
          }
        }

      }
    }

  }
</style>
